import { render, staticRenderFns } from "./JixiaomanVisitor.vue?vue&type=template&id=40d1395a&scoped=true&"
import script from "./JixiaomanVisitor.vue?vue&type=script&lang=js&"
export * from "./JixiaomanVisitor.vue?vue&type=script&lang=js&"
import style0 from "./JixiaomanVisitor.vue?vue&type=style&index=0&id=40d1395a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d1395a",
  null
  
)

export default component.exports